import React from 'react';
import { MARQUEE } from '../../data/site';

const Run = () => (
  <span className="flex shrink-0">
    {Array.from({ length: 4 }).flatMap((_, i) =>
      MARQUEE.map((text) => (
        <span key={`${i}-${text}`} className="px-2">
          {text} ✦
        </span>
      ))
    )}
  </span>
);

const Marquee = () => (
  <div
    className="overflow-hidden whitespace-nowrap border-b-[3px] border-ink bg-ink py-2 text-sm font-bold tracking-[2px] text-sun"
    aria-hidden="true"
  >
    <div className="marquee-track">
      <Run />
      <Run />
    </div>
  </div>
);

export default Marquee;
